export default {
  getActivityDetail: '/v3/reward/activityDetail',
  getCurrentProgress: '/courier/api/h5/v2/reward/currentProgress',
  getGiftRecord: '/courier/api/h5/v2/reward/giftRecord',
  getActivityList: '/v3/reward/activityList',
  getBonus: '/courier/api/h5/v2/reward/getBonus',
  regionLocList: '/courier/api/h5/v2/regionLocList',
  getCount: '/courier/api/h5/v2/reward/homePage',
  getRecipientDetail: '/v3/recommend/recieverDetail',
  getRecord: '/v3/reward/record'
}
